/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Stock_Movement_Not_CancellableInputs */

const en_error_stock_movement_not_cancellable = /** @type {(inputs: Error_Stock_Movement_Not_CancellableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The movement cannot be cancelled: it waits for Operations, it is no longer open, or the warehouse already began to move it.`)
};

/**
* | output |
* | --- |
* | "The movement cannot be cancelled: it waits for Operations, it is no longer open, or the warehouse already began to move it." |
*
* @param {Error_Stock_Movement_Not_CancellableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_stock_movement_not_cancellable = /** @type {((inputs?: Error_Stock_Movement_Not_CancellableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Stock_Movement_Not_CancellableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_stock_movement_not_cancellable(inputs)
});